import '@/http-common'
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import { initInlineSvg } from '@/core/plugins/inline-svg'
import VueToast from 'vue-toast-notification'
import VueSlider from 'vue-slider-component'
import VueSweetalert2 from 'vue-sweetalert2'
import { tooltip } from '@/utils/tooltip.js'


import '@/core/plugins/keenthemes'
import 'bootstrap/dist/js/bootstrap.min'
import '@popperjs/core'
import { Dialog, Quasar } from 'quasar'
import pl from 'quasar/lang/pl'
import { resolveClientBranding } from '@/utils/client-branding'

/**
 * Stylesheets
 */
import 'quasar/dist/quasar.css'
import 'devextreme/dist/css/dx.light.css'
import '@vuepic/vue-datepicker/dist/main.css'
import 'vue-select/dist/vue-select.css'
import 'vue-toast-notification/dist/theme-sugar.css'
import 'vue-slider-component/theme/antd.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'animate.css'

/**
 * Font Awesome
 */
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
    faBed,
    faCarBattery,
    faDownload,
    faGasPump,
    faGaugeHigh,
    faGaugeSimpleHigh,
    faIdCard,
    faPause,
    faReplyAll,
    faRoad,
    faScrewdriverWrench,
    faTachographDigital,
    faTrash,
    faTruck,
    faTruckFast,
    faHourglassEnd,
    faBell
} from '@fortawesome/free-solid-svg-icons'

import mitt from 'mitt'
import DevExtremeConfig from 'devextreme/core/config';

const licenseKey = process.env.VUE_APP_DEVEXPREES_LICENSE_KEY;
DevExtremeConfig({ licenseKey });

library.add(faTruckFast, faScrewdriverWrench, faBed, faTruck, faIdCard, faPause, faRoad, faGasPump,
    faGaugeHigh, faCarBattery, faGaugeSimpleHigh, faTachographDigital, faDownload, faTrash, faReplyAll, faHourglassEnd,faBell)

async function bootstrap() {
    await resolveClientBranding()

    const app = createApp(App)
    const emitter = mitt()

    app.config.globalProperties.emitter = emitter

    app.use(router)
    app.use(i18n)
    app.use(VueToast, {
        position: 'bottom-right'
    })
    app.component('VueSlider', VueSlider)
    app.component('FontAwesomeIcon', FontAwesomeIcon)
    app.use(VueSweetalert2, {
        confirmButtonColor: '#f67f01'
    })
    app.use(Quasar, {
        plugins: {
            Dialog
        },
        lang: pl

    })
    app.directive('tooltip', tooltip)

    initInlineSvg(app)
    app.mount('#app')
}

void bootstrap()
